// extracted by mini-css-extract-plugin
export default {"base":"EfpyY","spinner":"dfYZG"};